export const generateInsightSections = [
  { id: "market-overview", label: "Market Overview" },
  { id: "spend", label: "Spend" },
  { id: "suppliers", label: "Suppliers" },
  { id: "cost-drivers", label: "Cost Drivers" },
  { id: "news", label: "News" },
  { id: "financial-reporting", label: "Financial Reporting" },
];
